import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Typography,
  CardActions
} from "@material-ui/core";
import {
  LocationOnOutlined,
  PhoneAndroid,
  PhonelinkLockOutlined,
} from "@material-ui/icons";
import { Rating } from "@material-ui/lab";
import React from "react";
import useStyle from "./Style";
function PlaceDetiels({ place ,selected, refProp}) {
  const classes = useStyle();
  // console.log(place);
  // console.log(selected,refProp)
   if (selected) refProp?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return (
    <div>
      <Card elevation={6}>
        <CardMedia
          style={{ height: 350 }}
          image={
            place?.photo
              ? place?.photo?.images?.large.url
              : "https://www.foodserviceandhospitality.com/wp-content/uploads/2016/09/Restaurant-Placeholder-001.jpg"
          }
          title={place?.name}
        />
        <CardContent>
          <Typography gutterBottom variant="h5">
            {" "}
            {place?.name}
          </Typography>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="subtitle1">Price</Typography>
            <Typography variant="subtitle1">{place?.price?._level}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Rating name="read-only"  value={Number(place.rating)} readOnly />
             <Typography variant="subtitle1">out of {place?.num_reviews} reviews</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="subtitle1">ranking</Typography>
            <Typography variant="subtitle1">{place?.ranking}</Typography>
          </Box>
          {place?.awards?.map((award) => (
            <Box
              my={1}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <img src={award?.images.small} alt={award?.display_name} />
              <Typography variant="subtitle2" color="textSecondary">
                {award?.display_name}
              </Typography>
            </Box>
          ))}
          {place?.cuisine?.map(({ name }) => (
            <Chip
              key={name}
              size="small"
              label={name}
              className={classes.chip}
            />
          ))}
          {place?.address && (
            <Typography
              gutterBottom
              variant="subtitle2"
              color="textSecondary"
              className={classes.subtitle}
            >
              <LocationOnOutlined /> {place.address}
            </Typography>
          )}
          {place?.phone && (
            <Typography
              gutterBottom
              variant="subtitle2"
              color="textSecondary"
              className={classes.spacing}
            >
              <PhoneAndroid /> {place.phone}
            </Typography>
          )}

          <CardActions>
            {
              place.web?._url? <Button
              size="small"
              color="primary"
              onClick={() => window.open(place.web?._url, "_blank")}
            >
              Trip Advisor
            </Button>:'',
            place?.website? <Button
              size="small"
              color="primary"
              onClick={() => window.open(place?.website, "_blank")}
            >
              website
            </Button>:''
            }
           
           
          </CardActions>
        </CardContent>
      </Card>
    </div>
  );
}

export default PlaceDetiels;
